import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import {
  DadosSolicitante,
  DadosUnidade,
  Municipio,
  Servico,
} from 'src/app/models/Servico.model';
import { ServicoService } from 'src/app/services/servico.service';

@Component({
  selector: 'app-formulario-solicitante',
  templateUrl: './formulario-solicitante.component.html',
  styleUrls: ['./formulario-solicitante.component.css'],
})
export class FormularioSolicitanteComponent implements OnInit, OnDestroy {
  TIPO_USUARIO_UNIDADE = ['Física', 'Jurídica'];

  @Input({ required: true }) servico: Servico | undefined;
  @Input() dadosUnidade: DadosUnidade | undefined;
  @Input() dadosSolicitante: DadosSolicitante | undefined;
  @Input() mostrarDeclaracoes: boolean = true;
  @Input() origem: string | undefined;
  @Output() onUnidadeEncontrada = new EventEmitter<DadosUnidade>();
  @Output() onEnviarSolicitante = new EventEmitter<DadosSolicitante>();
  unidadeSubscription!: Subscription;

  municipios: Municipio[] = [];
  municipioParam: string = '';
  loading = false;

  form!: FormGroup;
  formUnidade!: FormGroup;
  matricula: number | undefined | null = null;
  constructor(
    private fb: FormBuilder,
    private servicoService: ServicoService,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (!this.dadosSolicitante) this.dadosSolicitante = {};

      if (params['hparams']) {
        try {
          const hparams = decodeURIComponent(params['hparams']);

          const decodedParams =
            this.servicoService.descriptografarToken(hparams);

          const parsedParams = JSON.parse(decodedParams);

          if (parsedParams['nome'])
            this.dadosSolicitante.nomeSolicitante = parsedParams['nome'];

          if (parsedParams['matricula'] && !isNaN(parsedParams['matricula'])) {
            this.matricula = parsedParams['matricula'];

          }

          if (parsedParams['cpf']) {
            if (typeof parsedParams['cpf'] === 'string') {
              this.dadosSolicitante.cpfSolicitante = parsedParams['cpf'].replace(/[^\d]/g, '');
            } else {
              this.dadosSolicitante.cpfSolicitante = parsedParams['cpf'];
            }
          }
          if (parsedParams['email'])
            this.dadosSolicitante.emailSolicitante = parsedParams['email'];
          if (parsedParams['fone'])
            this.dadosSolicitante.telefoneSolicitante = parsedParams['fone'];
          if (parsedParams['municipio']) {
            this.municipioParam = parsedParams['municipio'];
          }
        } catch (error) {
          console.error('Erro ao decodificar hparams:', error);
        }
      } else {
        if (params['nome'])
          this.dadosSolicitante.nomeSolicitante = params['nome'];

        if (params['matricula'] && !isNaN(params['matricula'])) {
          this.matricula = params['matricula'];
        }

        if (params['cpf']) {
          this.dadosSolicitante.cpfSolicitante = params['cpf'];
        }
        if (params['email'])
          this.dadosSolicitante.emailSolicitante = params['email'];
        if (params['fone'])
          this.dadosSolicitante.telefoneSolicitante = params['fone'];
        if (params['municipio']) {
          this.municipioParam = params['municipio'];
        }
      }
    });

    this.servicoService.getMunicipios().subscribe({
      next: (munResponse) => {
        this.municipios = munResponse;

        if (this.municipioParam != '') {
          let mun = munResponse.filter(
            (m) =>
              this.removeAccents(m.nome).localeCompare(
                this.removeAccents(this.municipioParam),
                undefined,
                { sensitivity: 'base' }
              ) == 0
          )[0];

          if (mun != null && mun != undefined)
            this.form.controls['municipio'].setValue(
              this.getMunicipioFromId(mun.id)
            );
        }
      },
      error: () => {
        this._addErrorMessage(
          'Erro ao carregar lista de municipios, tente novamente mais tarde'
        );
      },
    });

    this.formUnidade = this._criaFormularioUnidade();
    this.form = this._criaFormularioSolicitante();

    this.form.get('naoPossuiEmail')?.valueChanges.subscribe((value) => {
      const emailControl = this.form.get('emailSolicitante');
      emailControl?.setValue(value ? 'experiencia@casan.com.br' : '');
      emailControl?.updateValueAndValidity();
    });
  }

  removeAccents(str: string) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  ngOnDestroy(): void {
    if (this.unidadeSubscription) {
      this.unidadeSubscription.unsubscribe();
    }
  }

  getMunicipioFromNome(nome: string): Municipio | undefined | null {
    return null;
  }

  getMunicipioFromId(
    id: number | undefined | null
  ): Municipio | undefined | null {
    if (!id) return null;

    return this.municipios.find((mun) => mun.id == id);
  }

  enviarSolicitante() {
    this.loading = true;
    this.onEnviarSolicitante.emit({
      ...this.form.value,
      municipioId: this.form.getRawValue()['municipio']?.id,
    });
  }

  buscarUnidade() {
    this.loading = true;
    this.formUnidade.disable();

    this.unidadeSubscription = this.servicoService
      .getUnidade({
        cpfCnpjUnidade: this.formUnidade.get('cpfCnpjUnidade')?.getRawValue(),
        matricula: this.formUnidade.get('matricula')?.getRawValue(),
        id: this.servico?.id,

      })
      .subscribe({
        next: (retorno) => {
          this.onUnidadeEncontrada.emit({
            ...retorno,
            tipoUsuarioUnidade:
              this.formUnidade.value['tipoUsuarioUnidade']?.charAt(0),
          });
          this.form.controls['municipio'].setValue(
            this.getMunicipioFromId(retorno.municipioId)
          );
        },
        error: (error) => {
          this.formUnidade.enable();
          this._addErrorMessage(error.error.message);
          this.loading = false;
        },
        complete: () => {
          this.formUnidade.enable();
          this.loading = false;
        },
      });
  }

  limparCpfCnpj() {
    let ehPessoaFisica =
      this.formUnidade.value['tipoUsuarioUnidade'] ==
      this.TIPO_USUARIO_UNIDADE[0];
    let campoDocumento = this.formUnidade.value['cpfCnpjUnidade'];
    if (ehPessoaFisica && campoDocumento?.length == 14)
      this.formUnidade.get('cpfCnpjUnidade')?.setValue('');

    if (!ehPessoaFisica && campoDocumento?.length == 11)
      this.formUnidade.get('cpfCnpjUnidade')?.setValue('');
  }

  _addErrorMessage(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: message,
      life: 5000,
    });
  }

  _criaFormularioSolicitante(): FormGroup {
    let formFields: any = {
      nomeSolicitante: [
        this.dadosSolicitante?.nomeSolicitante,
        [Validators.required],
      ],
      cpfSolicitante: [
        this.dadosSolicitante?.cpfSolicitante,
        [Validators.required, Validators.pattern(/^(\D*\d){11}\D*$/)],
      ],
      naoPossuiEmail: [false],
      emailSolicitante: [
        this.dadosSolicitante?.emailSolicitante,
        [Validators.required, Validators.email],
      ],
      telefoneSolicitante: [
        this.dadosSolicitante?.telefoneSolicitante,
        [Validators.required],
      ],
      municipio: [
        {
          value: this.getMunicipioFromId(this.dadosSolicitante?.municipioId),
          disabled: this.servico?.comMatricula,
        },
        [Validators.required],
      ]
    };

    if (this.mostrarDeclaracoes) {
      formFields.tipoUsuario = [this.dadosSolicitante?.tipoUsuario, [Validators.required]];
      formFields.declaracaoVeracidade = [null, Validators.required];
      formFields.declaracaoAceite = [null, Validators.required];
    }

    if (this.servico?.solicitarDetalhesEndereco) {
      formFields.endereco = [
        this.dadosSolicitante?.endereco,
        [Validators.required],
      ];

      formFields.complementoEndereco = [
        this.dadosSolicitante?.complementoEndereco,
        [Validators.required],
      ];

      formFields.bairro = [
        this.dadosSolicitante?.bairro,
        [Validators.required],
      ];
    }

    return this.fb.group(formFields);
  }

  _criaFormularioUnidade(): FormGroup {
    const cpf = this.dadosSolicitante?.cpfSolicitante || '';

    return this.fb.group({
      tipoUsuarioUnidade: ['Física', Validators.required],
      cpfCnpjUnidade: [
        cpf,
        [
          Validators.required,
          Validators.pattern(/^(\D*\d){11}\D*$|^(\D*\d){14}\D*$/),
        ],
      ],
      matricula: [this.matricula, Validators.required],
    });
  }
}
